__turbopack_context__.v({
  "amount": "bB-qmG_amount",
  "content": "bB-qmG_content",
  "icon": "bB-qmG_icon",
  "paragraph": "bB-qmG_paragraph",
  "productsNumber": "bB-qmG_productsNumber",
  "wrapper": "bB-qmG_wrapper",
});
